import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})
export class FacultyPortalService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  // Home Work

  SaveTeacherHomeWork(data, file): Observable<any> {
    let formData = new FormData();
    formData.append("objstr", data);
    formData.append("FileUpload", file);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'FacultyPortal/SaveTeacherHomeWork', formData);
  }

  GetTeacherHomeWorkAdmin(filter): Observable<any> {
    let formData = new FormData();
    formData.append("filter", filter);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'FacultyPortal/GetTeacherHomeWorkAdmin', formData);
  }

  GetSubmitedStudentHomeWork(filter): Observable<any> {
    let formData = new FormData();
    formData.append("homeworkID", filter);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'FacultyPortal/GetSubmitedStudentHomeWork', formData);
  }

  StudentHomeWorkMarkActive(data, IsActive): Observable<any> {
    let formData = new FormData();
    formData.append("HomeWorkID", data);
    formData.append("IsActive", IsActive);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'FacultyPortal/StudentHomeWorkMarkActive', formData);
  }

  CommentTeacherHomeWork(StudentID, HomeWorkID, TearcherComment): Observable<any> {
    let formData = new FormData();
    formData.append("StudentID", StudentID);
    formData.append("HomeWorkID", HomeWorkID);
    formData.append("TearcherComment", TearcherComment);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'FacultyPortal/CommentTeacherHomeWork', formData);
  }
  GetStudentHomeWorkFile(strData):Observable<any>{   
    
    var formData = new FormData();
         formData.append("obj", strData);
 var reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencoded','No-Auth':'True' });
 return this.httpclient.post<any>(this.globalHelper.ApiUrl+'FacultyPortal/GetStudentHomeWorkFile?',formData);
 
 }
  // Time Table


  GetTimeTableStaff(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'FacultyPortal/GetTimeTableStaff', { headers: reqHeader });
  }
 
  // Roll No Generation

  GetRollNumberGeneration(objStudent): Observable<any> {
    let formData = new FormData();
    formData.append("objStudent", objStudent);    
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'FacultyPortal/GetRollNumberGeneration', formData);
  }

  SaveRollNumberGeneration(ObjStudent, objList): Observable<any> {
    let formData = new FormData();
    formData.append("ObjStudent", ObjStudent);
    formData.append("objList", objList);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'FacultyPortal/SaveRollNumberGeneration', formData);
  }   
 

}
